import { getBranchDetails } from "../../../helpers/fakebackend_helper";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const reKyc_branchDetailsThunk = createAsyncThunk(
  "reKyc_branchDetailsThunk",
  async ({ params, token }) => {
    try {
      const response = getBranchDetails(params, token);
      return response;
    } catch (error) {
      return error;
    }
  }
);
